import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const productsJsmComplianceRoute: InvariantJiraRoute = {
	name: 'products-jsm-compliance',
	path: '/jira/settings/products/jira-service-management-compliance',
	exact: true,
};
